import { useAnimatedNumber } from '../hooks/useAnimatedNumber.js';
import { formatAmount } from '../utils/format.js';
import PropTypes from 'prop-types';

function AnimatedCell({ value, currency }) {
  const animated = useAnimatedNumber(value, 700);
  return <span>{formatAmount(animated, currency)}</span>;
}

AnimatedCell.propTypes = {
  value:    PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
}

export default function PayPeriodTable({ periods = [], currency = 'USD', displayCurrency, convert }) {
  if (!periods || periods.length === 0) return null;

  const displayCurr = displayCurrency || currency;

  const conv = (amt) => {
    if (displayCurrency && displayCurrency !== currency && convert) {
      return convert(amt, currency, displayCurrency);
    }
    return amt;
  };

  return (
    <div className="pay-period-table">
      <h3 className="pay-period-table__title">Pay Period Breakdown</h3>
      <div className="pay-period-table__scroll">
        <table className="pay-period-table__table">
          <thead>
            <tr>
              <th>Period</th>
              <th>Gross</th>
              <th>Tax</th>
              <th>Net</th>
            </tr>
          </thead>
          <tbody>
            {periods.map(({ key, label, gross, tax, net }) => (
              <tr key={key} className={key === 'annual' ? 'pay-period-table__row--highlight' : ''}>
                <td className="pay-period-table__period">
                  {key === 'annual' && <span className="pay-period-table__badge">Annual</span>}
                  {key !== 'annual' && label}
                </td>
                <td className="pay-period-table__gross">
                  <AnimatedCell value={conv(gross)} currency={displayCurr} />
                </td>
                <td className="pay-period-table__tax">
                  <AnimatedCell value={conv(tax)} currency={displayCurr} />
                </td>
                <td className="pay-period-table__net">
                  <AnimatedCell value={conv(net)} currency={displayCurr} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

PayPeriodTable.propTypes = {
  periods: PropTypes.arrayOf(PropTypes.shape({
    key:   PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    gross: PropTypes.number.isRequired,
    tax:   PropTypes.number.isRequired,
    net:   PropTypes.number.isRequired,
  })),
  currency:        PropTypes.string,
  displayCurrency: PropTypes.string,
  convert:         PropTypes.func,
}

PayPeriodTable.defaultProps = {
  periods:         [],
  currency:        'USD',
  displayCurrency: undefined,
  convert:         undefined,
}